module.exports = __webpack_public_path__ + "img/chez-oscar.9929bffd.jpg";